// extracted by mini-css-extract-plugin
export default {"infoPage":"InfoPage_infoPage__XDChb"};